import { setGlobal } from "reactn";
import { metadataConstants } from "./actionTypes";
import { metadataService } from "services/metadata.service";
import { missionId } from "utils/urls";

export const metadataActions = {
  receiveMetadata,
};

const locationContainsMission = () => {
  const noMissionUrls = ["/error", "/consent", "/login-init", "/"];
  return !noMissionUrls.some((url) => url === window?.location?.pathname);
};

export function receiveMetadata() {
  return (dispatch) => {
    if (locationContainsMission()) {
      dispatch(request(missionId));
      return metadataService
        .getMetadata(missionId)
        .then((response) => {
          if (!response.ok) {
            return dispatch(failure(response));
          }
          response.json().then(function (data) {
            sessionStorage.setItem(missionId, JSON.stringify(data));
            const missionMetadata = sessionStorage.getItem(missionId);
            setGlobal(JSON.parse(missionMetadata)).then(() => {
              dispatch(success(data));
            });
          });
        })
        .catch((error) => {
          dispatch(failure(error));
        });
    } else {
      return null;
    }
  };

  function request(missionId) {
    return {
      type: metadataConstants.METADATA_REQUEST,
      missionId,
    };
  }

  function success(metadata) {
    return {
      type: metadataConstants.METADATA_SUCCESS,
      metadata,
    };
  }

  function failure(message) {
    return {
      type: metadataConstants.METADATA_REQUEST,
      message,
    };
  }
}
